export default __webpack_public_path__ + "static/media/jacquard fabrics.9e41a321.jpg";